import React from 'react';
import PatientPaymentsCard from '../../Patients/Patientdetails/PaymentsCard/PatientPaymentsCard';
import {useSelector} from 'react-redux';

function PaymentsContainer(): JSX.Element {
  // FIXME: ADD PROPER TYPES
  const patientDetailsDrawer = useSelector(
    (state: any) => state.patientDetailsDrawer
  );

  return (
    <PatientPaymentsCard
      guarantorId={patientDetailsDrawer?.patientDetails?.guarantor_id}
      clinicId={patientDetailsDrawer?.clinicId}
    />
  );
}

export default PaymentsContainer;
